// @mui
import { Stack, Grid, Button } from '@mui/material';
// hooks
import { useEffect, useState } from 'react';
import BlogCard from './BlogCard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { UserTableToolbar } from 'src/sections/@dashboard/user/list';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { BlogModal } from './BlogModal';
import { useBlogs } from '../useBlogs';
import { Blog } from 'src/@types/blog';
import { Typography } from '@mui/material';

// ----------------------------------------------------------------------
const Sort_Options = ['all', 'acs', 'desc'];

// ----------------------------------------------------------------------

export default function BlogList() {
  const {
    modalOpen,
    setModalOpen,
    confirmationOpen,
    setConfirmationOpen,
    filterName,
    filterRole,
    currentBlog,
    setCurrentBlog,
    filteredData,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getBlogList,
  } = useBlogs();

  useEffect(() => {
    getBlogList().catch(console.error);
  }, []);

  const [confirmOpen, setConfirmOpen] = useState({ open: false, currentId: '' });

  return (
    <Stack>
      <HeaderBreadcrumbs
        heading="Blog List"
        links={[
          { name: 'Dashboard', href: PATH_DASHBOARD.root },
          { name: 'Blog List', href: PATH_DASHBOARD.blogs },
        ]}
        action={
          <Button
            variant="contained"
            onClick={() => setModalOpen(true)}
            startIcon={<Iconify icon={'eva:plus-fill'} />}
          >
            New Blog
          </Button>
        }
      />
      <UserTableToolbar
        small={true}
        placeholder="Search Blog..."
        filterName={filterName}
        filterRole={filterRole}
        onFilterName={handleFilterName}
        onFilterRole={() => {}}
        optionsRole={Sort_Options}
      />
      <Grid container>
        {filteredData.map((blog: Blog, index: number) => (
          <Grid
            spacing={1}
            key={blog._id}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            rowSpacing={1}
            columnSpacing={1}
          >
            <BlogCard
              blog={blog}
              key={index}
              handleEditRow={() => handleEditRow(blog)}
              handleDeleteRow={() => {
                setConfirmOpen({ open: true, currentId: blog._id });
              }}
            />
          </Grid>
        ))}
        {filteredData.length === 0 && (
          <Stack width={'100%'} height="300px" alignItems={'center'} justifyContent="center">
            <Typography> No result for your search data</Typography>
          </Stack>
        )}
      </Grid>
      <BlogModal
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
          getBlogList();
          setCurrentBlog(undefined);
        }}
        isEdit={currentBlog ? true : false}
        currentBlog={currentBlog}
      />
      <ConfirmationDialog
        headText={'Delete Blog'}
        text={'Are You Sure You Need To Delete This Blog'}
        isOpen={confirmOpen.open}
        onClose={() => {
          setConfirmOpen({ open: false, currentId: '' });
          getBlogList();
        }}
        confirmAction={() => {
          handleDeleteRow(confirmOpen.currentId);
        }}
        loading={false}
      />
    </Stack>
  );
}
